export interface INotificationsSet {
	org_id: string | number;
	name: string | null;
	active: boolean;
	subscriptions: {
		zesty_disk: IZestyDiskNotifications;
		unused_resources: INotificationUnusedResources;
	};
	targets: {
		slack: {
			subscribed: boolean;
			channels: string[];
		};
		teams: {
			subscribed: boolean;
		};
		email: {
			subscribed: boolean;
			emails: string[];
		};
	};
}

export interface IListSubscription {
	eventName: string;
	product: string;
	severity: string;
	subscribed: boolean;
}

export interface IListTarget {
	subscribed: boolean;
	target_name: string;
	target_path: string;
}

export interface IListNotificationsSet {
	org_id: string | number;
	name: string | null;
	active: boolean;
	subscriptions: IListSubscription[];
	targets: IListTarget[];
}

export interface ISlackChannels {
	channels: string[];
}

export type SlackChannels = string[];

export interface IInputTimeOptions {
	value: number;
	display: string;
}

export interface IZestyDiskNotifications {
	critical: {
		zesty_disk_resize_failures: {
			subscribed: boolean;
		};
		// zesty_disk_agent_stop_reporting: {
		// 	subscribed: boolean;
		// 	threshold: number;
		// 	snooze_hours: number;
		// };
		// zesty_disk_filesystem_free_space: {
		// 	subscribed: boolean;
		// 	threshold: number;
		// };
	};
	info: {
		monitored_fs_utilization: {
			subscribed: boolean;
			threshold: number;
			snooze_hours: number;
		};
		zesty_disk_fs_size: {
			subscribed: boolean;
			threshold: number;
			snooze_hours: number;
		};
		zesty_disk_resize_events: {
			subscribed: boolean;
		};
	};
}

export interface INotificationUnusedResources {
	info: {
		unused_resources_policy_update: {
			subscribed: boolean;
		};
		unused_resources_actions: {
			subscribed: boolean;
		};
	};
}

export interface INotificationSubscriptions {
	zesty_disk: any;
	unused_resources: any;
}

export interface IBaseNotificationPayload {
	org_id: number;
	name: string;
}

export interface INotificationPayload extends IBaseNotificationPayload {
	active: boolean;
	subscriptions: INotificationSubscriptions;
	targets: any;
}

export enum NotificationFormControlIds {
	name = 'name',
	utilizationThreshold = 'subscriptions.zesty_disk.info.monitored_fs_utilization.threshold',
	lowFreeSpaceThreshold = 'subscriptions.zesty_disk.critical.zesty_disk_filesystem_free_space.threshold',
	utilizationSnooze = 'subscriptions.zesty_disk.info.monitored_fs_utilization.snooze_hours',
	agentStoppedReportingSnooze = 'subscriptions.zesty_disk.critical.zesty_disk_agent_stop_reporting.snooze_hours',
	agentStoppedReportingThreshold = 'subscriptions.zesty_disk.critical.zesty_disk_agent_stop_reporting.threshold',
	diskSizeThreshold = 'subscriptions.zesty_disk.info.zesty_disk_fs_size.threshold',
	diskSizeSnooze = 'subscriptions.zesty_disk.info.zesty_disk_fs_size.snooze_hours',
	zestyCritical = 'zesty_disk.critical',
	zestyInfo = 'zesty_disk.info',
	unusedResourcesCritical = 'unused_resources.critical',
	unusedResourcesInfo = 'unused_resources.info',
}

export enum SubFormStatus {
	partial = 'partial',
	empty = 'empty',
	full = 'full',
}

export type Partial<T> = {
	[P in keyof T]?: T[P];
};

export enum NotificationModalStrings {
	deleteMessage = 'Are you sure you want to delete this set?',
	deleteTitle = 'Are you sure you want to delete this set?',
}

export enum IntegrationOptions {
	teams = 'Teams',
	slack = 'Slack',
}

export interface ISubscriptionControl {
	subscribed: boolean;
}

export interface IEditResponse {
	Success: boolean;
}
